import {Action} from '@ngrx/store';
import { Auth } from 'src/app/auth/models/auth';

export class BaseAction implements Action {
  readonly type: string;

  /**
   * @param ownerCode For the DynaConf actions that write a `dynaData` slot: the route code of the
   * slot the dispatcher OWNS. The reducer refuses to write without it — see the ownership rule in
   * `shared.reducers.ts`. Actions whose payload is an envelope (FilterChange, PaginationSortChange)
   * carry it as `payload.code` instead; this parameter exists for the ones whose payload is a bare
   * value (a row, a boolean, an item list) and has nowhere to put it.
   */
  constructor(private ptype: any ,  public payload: any = null, public ownerCode?: string) {
    this.type = ptype;
  }
}

/** Payload for {@link SessionActionType.APPLY_SESSION}. */
export interface ApplySessionPayload {
  auth: Auth;
  enrollmentRequired: boolean;
}

/**
 * Cross-slice session action. Applying a freshly issued token sets two facts at once — the non-secret
 * identity slice (`auth`) AND the forced-2FA-enrollment flag (`twoFactor.enrollmentRequired`). Both
 * reducers key off this SINGLE action so the two update atomically in one state emission.
 *
 * This is the SINGLE writer of both slices — login, cross-tab sync, AND teardown (apply with EMPTY_AUTH +
 * enrollmentRequired:false). It replaces the old "dispatch a separate enrollment set/clear, then dispatch
 * FULL" pair that was hand-ordered at every apply site: a watcher reacting to `isAuthenticated` becoming
 * true (e.g. LoginComponent's `withLatestFrom(selectEnrollmentRequired)`) must never observe the new auth
 * identity alongside a stale enrollment flag, or a forced-enrollment user would burn their captured
 * deep-link via consumeReturnUrl() before being bounced to the wizard. One atomic action removes that
 * ordering footgun.
 */
export enum SessionActionType {
  APPLY_SESSION = '[Auth] Apply Session',
}
